import { render } from "./MainManu.vue?vue&type=template&id=76a5acbc&scoped=true"
import script from "./MainManu.vue?vue&type=script&lang=js"
export * from "./MainManu.vue?vue&type=script&lang=js"

import "./MainManu.vue?vue&type=style&index=0&id=76a5acbc&scoped=true&lang=less"

import exportComponent from "D:\\过去云盘内容\\前端代码\\前端项目\\rdsv3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a5acbc"]])

export default __exports__